<template>
    <v-select
        v-model="query.sort"
        v-bind="{
            ...attrs_input,
            loading,
            items,
            label: '정렬',
        }"
        @input="emit"
    />
</template>

<script>
import { attrs_input } from "@/assets/variables";

const items = [
    { value: null, text: "지원일↓" },
    { value: JSON.stringify({ _appliedAt: 1, _id: -1 }), text: "지원일↑" },
    { value: JSON.stringify({ "resume.personalInformation.name": 1, _id: -1 }), text: "이름↑" },
    { value: JSON.stringify({ "resume.personalInformation.name": -1, _id: -1 }), text: "이름↓" },
];

const initQuery = (query = {}) => ({
    ...(query || {}),
    sort: query.sort || null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
        focused: false,

        attrs_input,
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.sort) delete query.sort;

            this.$router.push({ query });
        },
        onFocus(...params) {
            console.log(params);
        },
    },
};
</script>

<style lang="scss" scoped></style>
